import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import Cookies from 'js-cookie';
import { fg } from '@atlaskit/platform-feature-flags';
import { CategoryStorageType } from '../../../types';
import { CacheLoader } from '../load-storage-controls-data';
import { Logger } from '../logger';
var analyticsEnabledGlobalState;
var productGlobalState;
var perimeterGlobalState;
var webStorageControlsEnabledGlobalState;
var localConsentModeGlobalState;
var packageDebugModeEnabledGlobalState;
var allowUncategorizedCookiesInOverridesGlobalState;
var hasInitialized = false;
var cookiesCacheLoader;
var localStorageCacheLoader;
var sessionStorageCacheLoader;
var loadCache = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(storageType) {
    var _cookiesCacheLoader, _localStorageCacheLoa, _sessionStorageCacheL;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.t0 = storageType;
          _context.next = _context.t0 === CategoryStorageType.Cookies ? 3 : _context.t0 === CategoryStorageType.LocalStorage ? 6 : _context.t0 === CategoryStorageType.SessionStorage ? 9 : 12;
          break;
        case 3:
          _context.next = 5;
          return (_cookiesCacheLoader = cookiesCacheLoader) === null || _cookiesCacheLoader === void 0 ? void 0 : _cookiesCacheLoader.loadStorageControlsData();
        case 5:
          return _context.abrupt("return", _context.sent);
        case 6:
          _context.next = 8;
          return (_localStorageCacheLoa = localStorageCacheLoader) === null || _localStorageCacheLoa === void 0 ? void 0 : _localStorageCacheLoa.loadStorageControlsData();
        case 8:
          return _context.abrupt("return", _context.sent);
        case 9:
          _context.next = 11;
          return (_sessionStorageCacheL = sessionStorageCacheLoader) === null || _sessionStorageCacheL === void 0 ? void 0 : _sessionStorageCacheL.loadStorageControlsData();
        case 11:
          return _context.abrupt("return", _context.sent);
        case 12:
          return _context.abrupt("return", undefined);
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function loadCache(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var getBscGlobalState = function getBscGlobalState() {
  return {
    analyticsEnabled: analyticsEnabledGlobalState !== null && analyticsEnabledGlobalState !== void 0 ? analyticsEnabledGlobalState : true,
    product: productGlobalState,
    perimeter: perimeterGlobalState,
    webStorageEnabled: webStorageControlsEnabledGlobalState !== null && webStorageControlsEnabledGlobalState !== void 0 ? webStorageControlsEnabledGlobalState : false,
    localConsentMode: localConsentModeGlobalState !== null && localConsentModeGlobalState !== void 0 ? localConsentModeGlobalState : false,
    packageDebugMode: packageDebugModeEnabledGlobalState,
    allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverridesGlobalState !== null && allowUncategorizedCookiesInOverridesGlobalState !== void 0 ? allowUncategorizedCookiesInOverridesGlobalState : false,
    cookiesCacheLoader: cookiesCacheLoader,
    localStorageCacheLoader: localStorageCacheLoader,
    sessionStorageCacheLoader: sessionStorageCacheLoader,
    loadCache: loadCache,
    hasInitialized: hasInitialized
  };
};
export var initializeGlobalState = function initializeGlobalState() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    webStorageEnabled = _ref2.webStorageEnabled,
    allowUncategorizedCookiesInOverrides = _ref2.allowUncategorizedCookiesInOverrides,
    _ref2$localConsentMod = _ref2.localConsentMode,
    localConsentMode = _ref2$localConsentMod === void 0 ? false : _ref2$localConsentMod,
    _ref2$product = _ref2.product,
    product = _ref2$product === void 0 ? 'all' : _ref2$product,
    _ref2$perimeter = _ref2.perimeter,
    perimeter = _ref2$perimeter === void 0 ? 'commercial' : _ref2$perimeter,
    _ref2$analyticsEnable = _ref2.analyticsEnabled,
    analyticsEnabled = _ref2$analyticsEnable === void 0 ? true : _ref2$analyticsEnable;
  Logger.debug('Initialize global state invoked');

  // If the app provides a value for product only in one place,
  // we want that value to be sticky and to override the default if necessary
  if ((!productGlobalState || productGlobalState == null || productGlobalState === 'all') && product) {
    productGlobalState = product;
  }

  // Treating webStorageEnabled and allowUncategorizedCookiesInOverrides differently
  // because they are only passed through initializeControls and
  // we don't want it to be defaulted to false via a call from the ConsentBanner
  if (webStorageEnabled !== undefined && webStorageControlsEnabledGlobalState === undefined) {
    webStorageControlsEnabledGlobalState = webStorageEnabled && !fg('platform_moonjelly_bsc_master_killswitch') && !fg('platform_moonjelly_bsc_web_storage_killswitch');
  }
  if (allowUncategorizedCookiesInOverrides !== undefined && allowUncategorizedCookiesInOverridesGlobalState === undefined) {
    allowUncategorizedCookiesInOverridesGlobalState = allowUncategorizedCookiesInOverrides;
  }

  // All other state can only be initialized once and is defaulted if not passed on the first initialization
  if (hasInitialized) {
    return;
  }
  if (!fg('fedramp-cookies-controls')) {
    localConsentModeGlobalState = localConsentMode;
  } else {
    // Force local consent mode when in the FedRAMP Moderate perimeter because ConsentHub is
    // not hydrated in the perimeter as of this comment
    localConsentModeGlobalState = localConsentMode || perimeter === 'fedramp-moderate';
  }
  analyticsEnabledGlobalState = analyticsEnabled;
  perimeterGlobalState = perimeter;
  cookiesCacheLoader = new CacheLoader(CategoryStorageType.Cookies, perimeter);
  localStorageCacheLoader = new CacheLoader(CategoryStorageType.LocalStorage, perimeter);
  sessionStorageCacheLoader = new CacheLoader(CategoryStorageType.SessionStorage, perimeter);
  if (fg('platform_moonjelly_bsc_debug_mode')) {
    packageDebugModeEnabledGlobalState = Boolean(Cookies.get('atl-bsc-debug-mode'));
  }
  hasInitialized = true;
};
export var testing_overrideGlobalState = function testing_overrideGlobalState(_ref3) {
  var overrideLoadCache = _ref3.loadCache,
    overrideProduct = _ref3.product;
  if (overrideLoadCache) {
    loadCache = overrideLoadCache;
  }
  if (overrideProduct) {
    productGlobalState = overrideProduct;
  }
};
export var clearGlobalState = function clearGlobalState() {
  analyticsEnabledGlobalState = undefined;
  productGlobalState = undefined;
  webStorageControlsEnabledGlobalState = undefined;
  localConsentModeGlobalState = undefined;
  packageDebugModeEnabledGlobalState = undefined;
  allowUncategorizedCookiesInOverridesGlobalState = undefined;
  cookiesCacheLoader = undefined;
  localStorageCacheLoader = undefined;
  sessionStorageCacheLoader = undefined;
  hasInitialized = false;
};